import React from 'react'
import './WorkCard.css'
import WorkCard from './WorkCard'
import { projectCarddata } from './WorkCardData'

const Work = () => {
  return (
    <div className='work-container'>
        <h1 className='project-heading'> Projects </h1>
        <div className="project-container">
           {projectCarddata.map((val, index) => {
            return (
                <WorkCard 
                    key={index}
                    imgsrc={val.Imgsrc}
                    title={val.title}
                    text={val.text}
                    view={val.view}
                    sources={val.sources}
                />
            )
            })}
        </div>
    </div>
  )
}

export default Work